import {focusTarget, focusScrollPosition} from '@/utils/employeeWorkforcePlanNavigation';

export default {
    provide() {
        return {focusWorkforcePlan: route => this.openFocusedPlan(route)};
    },
    data: () => ({focusedEmployeeId: null, routeFocusApplied: false, routeFocusMessage: ''}),
    beforeDestroy() {
        window.clearTimeout(this._routeFocusTimer);
    },
    methods: {
        async openFocusedPlan(route) {
            if (this.saving || this.arrivalDraft.pending || this.arrivalDraft.cancelling) return;
            if (this.editorDirty) {
                const discard = await this.$bvModal.msgBoxConfirm(
                    'В плане есть несохранённые изменения. Перейти к сотруднику без сохранения?',
                    {title: 'Несохранённый план', okTitle: 'Перейти без сохранения', cancelTitle: 'Остаться',
                        okVariant: 'warning', centered: true}
                );
                if (!discard || this._workforcePlanDestroyed) return;
            }
            if (this.saving || this.arrivalDraft.pending || this.arrivalDraft.cancelling) return;
            const resolved = this.$router.resolve(route).route;
            if (resolved.fullPath !== this.$route.fullPath) {
                await this.$router.push(route);
                return;
            }
            this.clearSelection();
            this.closeEmployeeInspector();
            const target = focusTarget(route.query);
            if (target && !this.weeks.some(week => week.visible_starts_on <= target.date && target.date < week.visible_ends_on)) {
                await this.navigatePlanPeriod(target.date);
                if (this._workforcePlanDestroyed) return;
            }
            this.routeFocusApplied = false;
            await this.applyRouteFocus();
        },
        async applyRouteFocus() {
            const target = focusTarget(this.$route && this.$route.query);
            if (!target || this.routeFocusApplied || !this.planWindowReady || this.loading || this.accessDenied) return;
            const requestId = this.loadRequestId;
            const key = this.planLoadKey();
            const stillCurrent = () => !this._workforcePlanDestroyed && requestId === this.loadRequestId
                && key === this.planLoadKey() && !this.routeFocusApplied;
            const employee = this.employees.find(row => Number(row.employee_id) === target.employeeId);
            if (!employee) {
                this.routeFocusMessage = 'Сотрудник не отображается в плане за выбранный период';
                this.routeFocusApplied = true;
                return;
            }
            if (!this.filteredEmployees.some(row => Number(row.employee_id) === target.employeeId)) {
                this.clearAllPlanFilters();
            }
            await this.$nextTick();
            await new Promise(resolve => window.requestAnimationFrame(resolve));
            if (!stillCurrent()) return;
            const viewport = this.$refs.viewport;
            const row = this.filteredEmployees.findIndex(item => Number(item.employee_id) === target.employeeId);
            const column = this.weeks.findIndex(week => week.visible_starts_on <= target.date && target.date < week.visible_ends_on);
            if (!viewport || row < 0 || column < 0) return;
            // Keep the employee's name visible alongside the date on narrow screens.
            if (this.isMobileViewport) this.mobileContextPinned = true;
            const position = focusScrollPosition({
                row, column, rowHeight: this.isMobileViewport ? 38 : 30,
                contentOffset: this.employeeRowsContentOffset, viewport,
                pinnedWidth: this.pinnedColumnsWidth, weekWidth: parseInt(this.weekWidth, 10) || 30
            });
            viewport.scrollTop = position.top;
            this.setPlanScrollLeft(this.zoom === 'fit' ? 0 : position.left);
            this.updateVirtualEmployeeRange();
            await this.$nextTick();
            if (!stillCurrent()) return;
            this.routeFocusApplied = true;
            this.routeFocusMessage = '';
            this.focusedEmployeeId = target.employeeId;
            const profile = this.$el.querySelector(`[data-plan-employee-id="${target.employeeId}"] .workforce-plan-employee__profile`);
            if (profile) {
                profile.focus({preventScroll: true});
                // The mobile grid can extend below the document viewport. Its own
                // scroll position alone cannot reveal the last rows completely.
                const rect = profile.getBoundingClientRect();
                if (rect.bottom > window.innerHeight - 12) {
                    window.scrollBy({top: rect.bottom - window.innerHeight + 12, behavior: 'auto'});
                }
            }
            window.clearTimeout(this._routeFocusTimer);
            this._routeFocusTimer = window.setTimeout(() => {
                this.focusedEmployeeId = null;
            }, 5000);
        }
    }
};
